import {gql} from '@apollo/client';

export const OnboardPasswordMutation = gql`
  mutation OnboardPasswordMutation($fullName: String, $password: String) {
    updateCurrentUser(fullName: $fullName, password: $password) {
      ok
    }
  }
`;
